const capitalize = (string) => {
  return string
    .toLowerCase()
    .split(' ')
    .map((el) => {
      return el.charAt(0).toUpperCase() + el.slice(1)
    })
    .join(' ')
}

export function fullName(user) {
  if (user.firstName && user.lastName) {
    return capitalize(user.firstName + ' ' + user.lastName)
  } else if (user.firstName) {
    return capitalize(user.firstName)
  }

  return 'Anónimo'
}

export const customerFullName = (customer) => {
  if (customer.firstname && customer.lastname) {
    return capitalize(customer.firstname + ' ' + customer.lastname)
  } else if (customer.firstname) {
    return capitalize(customer.firstname)
  } else if (customer.lastname) {
    return capitalize(customer.lastname)
  }

  return 'Anónimo'
}
